export const SHOW_DIALOG = 'SHOW_DIALOG';
export const showDialog = (content: any, size: string, isOverlay: boolean = false) => {
  return {
    content: content,
    isVisible: true,
    isOverlay: isOverlay,
    type: SHOW_DIALOG,
    size: size
  };
};

export const HIDE_DIALOG = 'HIDE_DIALOG';
export const hideDialog = () => {
  return {
    type: HIDE_DIALOG
  };
};

export const CLOSE_ALL_DIALOGS = 'CLOSE_ALL_DIALOGS';
export const closeAllDialogs = () => {
  return {
    type: CLOSE_ALL_DIALOGS
  };
};